import React from "react";

function Arrows() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="44"
            height="44"
            fill="none"
            viewBox="0 0 44 44"
        >
            <path
                fill="#DF8D46"
                d="M31.62 12.814l-.434-.434a.61.61 0 00-.866 0l-5.846 5.846v-2.38a.614.614 0 00-.614-.612h-.612a.613.613 0 00-.612.612v4.908c0 .338.276.612.612.612h4.908a.613.613 0 00.612-.612v-.614a.613.613 0 00-.612-.612h-2.38l5.846-5.846a.615.615 0 00-.002-.868zm-10.828 9.782h-4.936a.613.613 0 00-.612.612v.62c0 .338.276.612.612.612h2.4l-5.876 5.874c-.24.24-.24.63 0 .87l.434.434c.24.24.63.24.87 0l5.876-5.874v2.398c0 .338.276.612.614.612h.62a.613.613 0 00.612-.612v-4.936a.612.612 0 00-.614-.61z"
            ></path>
            <path
                stroke="#DF8D46"
                strokeDasharray="10 10"
                strokeWidth="2"
                d="M1 1H43V43H1z"
            ></path>
        </svg>
    );
}

export default Arrows;
